import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, WA_LINK } from "./data";
import { WaIcon } from "./Reveal";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("Beranda");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header data-testid="navbar" className={`fixed top-0 inset-x-0 z-50 transition-[background-color,box-shadow,padding] duration-500 ${scrolled ? "bg-white/75 backdrop-blur-xl shadow-[0_10px_40px_-20px_rgba(11,42,138,0.35)] py-2" : "py-4"}`}>
      <div className="max-w-[1320px] mx-auto px-5 lg:px-10 flex items-center justify-between gap-6">
        <Logo />
        <nav className="hidden lg:flex items-center gap-1 rounded-full bg-white/60 backdrop-blur-md border border-white/70 p-1">
          {NAV.map((n) => (
            <a key={n.label} href={n.href} onClick={() => setActive(n.label)} data-testid={`nav-${n.href.slice(1)}`} className="relative px-4 py-2 text-[13px] font-semibold text-vnavy/80 hover:text-vnavy transition-colors">
              {active === n.label && <motion.span layoutId="navpill" className="absolute inset-0 rounded-full bg-vblue shadow-[0_6px_20px_-6px_rgba(21,80,224,0.7)]" transition={{ type: "spring", stiffness: 380, damping: 30 }} />}
              <span className={`relative ${active === n.label ? "text-white" : ""}`}>{n.label}</span>
            </a>
          ))}
        </nav>
        <a href={WA_LINK} target="_blank" rel="noreferrer" data-testid="nav-contact-btn" className="btn-nav btn-shine hidden sm:inline-flex items-center gap-2">
          <WaIcon /> Hubungi Kami
        </a>
        <button data-testid="mobile-menu-btn" onClick={() => setOpen(!open)} className="lg:hidden w-11 h-11 grid place-items-center rounded-full bg-vnavy text-white" aria-label="Menu">
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav data-testid="mobile-menu" initial={{ opacity: 0, y: -12 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -12 }} className="lg:hidden mx-5 mt-3 rounded-3xl bg-white/95 backdrop-blur-xl p-4 shadow-2xl flex flex-col">
            {NAV.map((n) => (
              <a key={n.label} href={n.href} onClick={() => setOpen(false)} className="py-3 px-3 font-semibold text-vnavy border-b border-slate-100 last:border-0">{n.label}</a>
            ))}
            <a href={WA_LINK} target="_blank" rel="noreferrer" className="mt-3 inline-flex justify-center items-center gap-2 rounded-full bg-[#1aa34a] text-white py-3 font-semibold"><WaIcon /> Hubungi Kami</a>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
